import React, { useState, useRef, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMessage,
  faXmark,
  faRotate,
  faPaperPlane,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "./ChatWidth.css";
import MyContext from "../../MyContext";
import MessageNotifierOwl from "../../images/wo-Sender.gif";
import MessageNotifierOwlClosed from "../../images/wo-Sender.gif";
import { LifeBuoy, FolderKanban } from "lucide-react";
import MessageNotifierBanner from "../../images/Wo Sender Fab Icon.svg";

// Dummy data for demonstration
const dummyMessages = [
  {
    id: 1,
    text: "Hello! How can I help you today?",
    isBot: true,
    timestamp: new Date(Date.now() - 3600000).toISOString(),
  },
  {
    id: 2,
    text: "I have a question about my order",
    isBot: false,
    timestamp: new Date(Date.now() - 3300000).toISOString(),
  },
];

const ChatBotWidget = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState("list");
  const [messages, setMessages] = useState(dummyMessages);
  const [newMessage, setNewMessage] = useState("");
  const [UserClient, setUserClient] = useState("");
  const [sessionUser, setSessionUser] = useState(null);
  const [quickMessage, setQuickMessage] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const messagesEndRef = useRef(null);
  // email
  const [user, setUser] = useState(false);
  const [profiles, setProfiles] = useState([]);

  //  const formatTime = (isoString) => {
  //   if (!isoString) return "";
  //   return new Date(isoString).toLocaleTimeString("en-IN", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //   });
  // };

  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";
  // const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);

  const baseUrl = "https://api.seobix.com/api/Support";
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const raw = sessionStorage.getItem("user");

    if (!raw) return;

    try {
      const user = JSON.parse(raw);

      if (user?.username && user?.email) {
        setSessionUser({
          name: user.username,
          email: user.email,
        });
      }
    } catch (err) {
      console.error("Session parse error", err);
    }
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    const userMessage = {
      id: messages.length + 1,
      text: newMessage,
      isBot: false,
      timestamp: new Date().toISOString(),
    };
    SendText();

    setMessages([...messages, userMessage]);
    setNewMessage("");

    // Simulate bot response
    setTimeout(() => {
      const botMessage = {
        id: messages.length + 2,
        text: "Thanks for your message! Our team will get back to you soon.",
        isBot: true,
        timestamp: new Date().toISOString(),
      };
      setMessages((prev) => [...prev, botMessage]);
    }, 1000);
  };

  const handleNewChat = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const name = sessionUser?.name || formData.get("name");
    const email = sessionUser?.email || formData.get("email");
    const phone = formData.get("phone");

    if (!name || !email || !phone) {
      console.error("Missing required fields");
      return;
    }

    setUserClient(phone);

    setUserDetails({
      name,
      email,
      phone,
    });

    const UserNew = {
      userMobile: phone,
      userEmail: email,
      userName: name,
    };

    SubmitNewUser(UserNew);

    setMessages([
      {
        id: 1,
        message: `Hello ${name}! How can we help you today?`,
        type: "BOT",
        datetime: new Date().toISOString(),
      },
    ]);

    setView("optionSelect");
  };

  //   Api Call Section
  const SubmitNewUser = async (TestBody) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      var raw = JSON.stringify(TestBody);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/submitChatUserDetails`,
        requestOptions,
      );

      if (res.status === 200) {
        // setView("chatHistory");
        const data = await res.json();
        // handleVerificationAfterSubmission();
        // toast.success(data.responseMessage);
      } else {
        const data = await res.json();
        // toast.error(data.responseMessage);
      }
    } catch (error) {}
  };

  const [verificationMethod, setVerificationMethod] = useState("email"); // email or mobile
  // Add new function to handle verification
  const handleVerification = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const searchValue = formData.get("verification");
    setUserClient(formData.get("verification"));

    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);

      const searchBody = {
        mobile: UserClient ? UserClient : searchValue,
        message: "",
      };

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(searchBody),
        redirect: "follow",
      };

      const res = await fetch(`${baseUrl}/getSupportChatsUser`, requestOptions);

      if (res.status === 200) {
        const data = await res.json();
        // Assuming the API returns chat history
        setMessages(data.response || dummyMessages);
        setView("chatHistory");
      } else {
        const data = await res.json();
        // Handle error - could add toast here
        console.error("Failed to fetch chat history");
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };
  // Add new function to handle verification
  const handleVerificationAfterSubmission = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);

      const searchBody = {
        mobile: UserClient,
        message: "",
      };

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(searchBody),
        redirect: "follow",
      };

      const res = await fetch(`${baseUrl}/getSupportChatsUser`, requestOptions);

      if (res.status === 200) {
        const data = await res.json();
        // Assuming the API returns chat history
        setMessages(data.response || dummyMessages);
        setView("chatHistory");
      } else {
        const data = await res.json();
        // Handle error - could add toast here
        console.error("Failed to fetch chat history");
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  const RefreshChat = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);

      const searchBody = {
        mobile: UserClient,
        message: "",
      };

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(searchBody),
        redirect: "follow",
      };

      const res = await fetch(`${baseUrl}/getSupportChatsUser`, requestOptions);

      if (res.status === 200) {
        const data = await res.json();
        // Assuming the API returns chat history
        setMessages(data.response || dummyMessages);
        setView("chatHistory");
      } else {
        const data = await res.json();
        // Handle error - could add toast here
        console.error("Failed to fetch chat history");
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  // send email
  const sendNewUserEmail = async (userDetails, newMessage, userClient) => {
    const payload = {
      to: ["support@Wo Sender.com"],
      keyid: "7a57255fbb9021f1ac3a52010aa0680h",
      keySecret:
        "1edf18a65735bc6560d62d12ea82b9d28b342157a345654eb5ed8eab2addc890",
      triggerId: "TR-483f5627e49c11f0ac3a42010aa0000f",
      variables: {
        visitor_name: userDetails.name,
        visitor_email: userDetails.email,
        visitor_mobile: userClient,
        chat_message: newMessage,
        dashboard_url: "https://admin.Wo Sender.com",
      },
    };

    try {
      await fetch("https://api.shubhpaisa.com/api/ShubhPaisa/SendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("EMAIL API ERROR:", err);
    }
  };

  const SendText = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);

      const searchBody = {
        mobile: UserClient,
        message: newMessage,
      };

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(searchBody),
        redirect: "follow",
      };

      const res = await fetch(`${baseUrl}/sendSupportChatUser`, requestOptions);

      if (res.status === 200) {
        const data = await res.json();
        if (data.response.extra === "Y") {
          sendNewUserEmail(userDetails, newMessage, UserClient);
        } else {
        }

        // Assuming the API returns chat history
        // setMessages(data.response || dummyMessages);
        RefreshChat();
        setView("chatHistory");
      } else {
        const data = await res.json();
        RefreshChat();
        // Handle error - could add toast here
        console.error("Failed to fetch chat history");
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  const [showOwl, setShowOwl] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowOwl((prev) => !prev);
    }, 700); // Toggle every 1 second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // send email

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");

    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(true);
      setProfiles(parsedUser);
    } else {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (!profiles) return;

    const alreadySent = sessionStorage.getItem("welcomeEmailSent");

    if (profiles.userType === "new_user" && !alreadySent) {
      sendNewUserEmail(profiles);

      sessionStorage.setItem("welcomeEmailSent", "true");
    }
  }, [profiles]);

  return (
    <div className="custom_chat_container">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="custom_chat_button"
        style={{ display: isOpen ? "none" : "flex" }}
      >
        {showOwl ? (
          <img
            src={MessageNotifierOwl}
            alt="Owl"
            className="chatbot_owl_image"
          />
        ) : (
          <img
            src={MessageNotifierOwlClosed}
            alt="Owl"
            className="chatbot_owl_image"
          />
        )}
      </button>

      {/* Chat Widget */}
      {isOpen && (
        <div className="custom_chat_widget">
          <div className="custom_chat_header">
            <div className="custom_header_text">
              <h2 className="">
                Hello{" "}
                <span className="custom_user_name">
                  {sessionUser?.name || ""}
                </span>{" "}
                <div className="wave custom_hand_waver">👋🏻</div>
              </h2>

              <h2 className="custom_header_title typewriter ">
                Welcome to Wo Sender{" "}
              </h2>
              <p className="custom_header_subtitle changing-text">
                Need help with <p className="word "></p> ?
              </p>
            </div>
            <div className="custom_header_buttons">
              {UserClient && (
                <button
                  onClick={() => RefreshChat()}
                  className="custom_header_button"
                >
                  <FontAwesomeIcon icon={faRotate} />
                </button>
              )}

              <button
                onClick={() => setIsOpen(false)}
                className="custom_header_button"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="custom_chat_content">
            {view === "list" && (
              <>
                <div className="custom_chat_card_banner">
                  <img className="fade-in" src={MessageNotifierBanner} alt="" />
                </div>

                {/* <div
                  onClick={() => setView("verifyUser")}
                  className="custom_chat_card"
                >
                  <div className="custom_card_header">
                    <div className="custom_card_info">
                      <div className="custom_avatar custom_avatar_continue">
                        <FontAwesomeIcon icon={faUser} />
                      </div>
                      <div className="custom_card_text">
                        <h5 className="custom_card_title">
                          Continue Conversation
                        </h5>
                        <p className="custom_card_subtitle">
                          View your chat history
                        </p>
                      </div>
                    </div>
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="custom_card_arrow"
                    />
                  </div>
                </div> */}

                <div
                  onClick={() => setView("newChat")}
                  className="custom_chat_card"
                >
                  <div className="custom_card_header">
                    <div className="custom_card_info">
                      <div className="custom_avatar custom_avatar_new">
                        <FontAwesomeIcon icon={faMessage} />
                      </div>
                      <div className="custom_card_text">
                        <h5 className="custom_card_title">Start Chat</h5>
                        <p className="custom_card_subtitle">
                          Get help from our team
                        </p>
                      </div>
                    </div>
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="custom_card_arrow"
                    />
                  </div>
                </div>

                <div className="d-flex flex-column">
                  <div className="flex-grow-1"></div>
                  <div className="text-mute d-flex align-items-end mt-auto">
                    <hr />
                    {/* <footer className="blockquote-footer text-center">
                      Welcome to Wo Sender Support
                    </footer> */}
                  </div>
                </div>
              </>
            )}
            {view === "verifyUser" && (
              <div className="custom_verification_container">
                {/* <div className="custom_verification_toggle color:">
                  {/* <button
                    className={`custom_toggle_button ${
                      verificationMethod === "email" ? "active" : ""
                    }`}
                    onClick={() => setVerificationMethod("email")}
                  >
                    Email
                  </button> */}
                {/* <button
                    className={`custom_toggle_button ${
                      verificationMethod === "mobile" ? "active" : ""
                    }`}
                    onClick={() => setVerificationMethod("mobile")}
                  >
                    Mobile
                  </button> 
                </div> */}

                <form
                  onSubmit={handleVerification}
                  className="custom_chat_form"
                >
                  {/* <div className="custom_form_group">
                    <label className="custom_form_label">
                      {verificationMethod === "email"
                        ? "Enter your Email"
                        : "Enter your Mobile Number"}
                    </label>
                    <input
                      name="verification"
                      required
                      className="custom_form_input"
                      type={verificationMethod === "email" ? "email" : "tel"}
                      placeholder={
                        verificationMethod === "email"
                          ? "your@email.com"
                          : "1234567890"
                      }
                    />
                  </div> */}
                  {/* <button type="submit" className="custom_submit_button">
                    Continue Chat
                  </button> */}
                  {/* <button
                    type="button"
                    onClick={() => setView("list")}
                    className="custom_back_button"
                  >
                    Back to Menu
                  </button> */}
                </form>
              </div>
            )}

            {view === "newChat" && (
              <form onSubmit={handleNewChat} className="custom_chat_form">
                <div className="custom_form_group">
                  <label className="custom_form_label">Name</label>
                  <input
                    name="name"
                    className="custom_form_input"
                    type="text"
                    value={sessionUser?.name || ""}
                    readOnly={!!sessionUser}
                    placeholder="Your Name"
                    required
                  />
                </div>

                <div className="custom_form_group">
                  <label className="custom_form_label">Email</label>
                  <input
                    name="email"
                    className="custom_form_input"
                    type="email"
                    value={sessionUser?.email || ""}
                    readOnly={!!sessionUser}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="custom_form_group">
                  <label className="custom_form_label">Mobile</label>
                  <input
                    name="phone"
                    className="custom_form_input"
                    type="tel"
                    placeholder="911xxxxxx"
                    required
                  />
                </div>

                <button type="submit" className="custom_submit_button">
                  Start Chat
                </button>

                <button
                  type="button"
                  onClick={() => setView("list")}
                  className="custom_back_button"
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "optionSelect" && (
              <div className="custom_option_container">
                <button
                  className="custom_option_button"
                  onClick={() => setView("projectGuide")}
                >
                  <FolderKanban size={22} /> Project Guide
                </button>

                <button
                  className="custom_option_button"
                  // onClick={() => setView("chatHistory")}
                  onClick={async () => {
                    const success = await handleVerificationAfterSubmission();
                    if (success) {
                      setView("chatHistory");
                    }
                  }}
                >
                  <LifeBuoy size={22} /> Chat Now
                </button>

                <hr />
                <div className="custom_footer_links">
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={async () => {
                      const success = await handleVerificationAfterSubmission();
                      if (success) {
                        setView("chatHistory");
                      }
                    }}
                  >
                    Help Center
                  </p>
                </div>
              </div>
            )}

            {view === "projectGuide" && (
              <>
                <div className="custom_project_grid">
                  <div className="new-card">
                    <button onClick={() => navigate("/WhatsApp/Onboarding")}>
                      <strong>Complete Onboarding</strong>
                      <span>View Details After Onboarding</span>
                    </button>
                  </div>

                  <button onClick={() => navigate("/Dashboard")}>
                    <strong>Dashboard</strong>
                    <span>View performance insights</span>
                  </button>

                  <button onClick={() => navigate("/WhatsApp/Manage")}>
                    <strong>Campaign</strong>
                    <span>Manage messaging campaigns</span>
                  </button>

                  <button onClick={() => navigate("/WhatsApp/Logs")}>
                    <strong>Logs</strong>
                    <span>Track message activity</span>
                  </button>

                  <button onClick={() => navigate("/WhatsApp/Template")}>
                    <strong>Template</strong>
                    <span>Create message templates</span>
                  </button>
                </div>

                <hr />
                <div className="custom_footer_links">
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={async () => {
                      const success = await handleVerificationAfterSubmission();
                      if (success) {
                        setView("chatHistory");
                      }
                    }}
                  >
                    Help Center
                  </p>
                  {/* <p>More</p> */}
                </div>

                <form
                  onSubmit={async (e) => {
                    e.preventDefault();

                    if (!quickMessage.trim()) return;
                    const success = await handleVerificationAfterSubmission();

                    if (success) {
                      setMessages((prev) => [
                        ...prev,
                        {
                          id: Date.now(),
                          message: quickMessage,
                          type: "SENT",
                          datetime: new Date().toISOString(),
                        },
                      ]);

                      setQuickMessage("");
                      setView("chatHistory");
                    }
                  }}
                  className="custom_chat_input_container"
                >
                  <div className="custom_chat_input_wrapper">
                    <input
                      type="text"
                      value={quickMessage}
                      onChange={(e) => setQuickMessage(e.target.value)}
                      placeholder="Type your message..."
                      className="custom_chat_input"
                    />
                    <button type="submit" className="custom_send_button">
                      <FontAwesomeIcon icon={faPaperPlane} />
                    </button>
                  </div>
                </form>
              </>
            )}

            {view === "chatHistory" && (
              <div className="custom_messages_container">
                {messages?.map((message) => (
                  <div
                    key={message?.id}
                    className={`custom_message ${
                      message?.type === "SENT"
                        ? "custom_message_user"
                        : "custom_message_bot"
                    }`}
                  >
                    <div className="custom_message_content">
                      <p>{message?.message}</p>
                      <span className="custom_message_time">
                        {message?.datetime}
                      </span>
                      {/* <span className="custom_message_time">
  {formatTime(m.datetime)}
</span> */}
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>
            )}
          </div>

          {view === "chatHistory" && (
            <form
              onSubmit={handleSubmit}
              className="custom_chat_input_container"
            >
              <div className="custom_chat_input_wrapper">
                <input
                  type="text"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  placeholder="Type your message..."
                  className="custom_chat_input"
                />
                <button type="submit" className="custom_send_button">
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatBotWidget;
